import type { NavigationGuard } from 'vue-router';

// Keep the app navigation bar when one tool opens another tool.
export const preserveWebAppContext: NavigationGuard = (to, from) => {
  if (to.meta.webAppChild && from.meta.webAppChild && from.query.app === '1' && to.query.app == null) {
    return { path: to.path, query: { ...to.query, app: '1' }, hash: to.hash };
  }
};
